import { render, staticRenderFns } from "./PermohonanNonberusaha.vue?vue&type=template&id=1fb3b443&"
import script from "./PermohonanNonberusaha.vue?vue&type=script&lang=js&"
export * from "./PermohonanNonberusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports